<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h5 class="mb-3">Search</h5>
                <div class="row">
                    <div class="col">
<!--                        <date-range-picker :label="'Period'" v-model="params.period"/>-->
                        <relative-absolut-date-range-picker :label="'Period'" v-model="params.period"/>

                    </div>
                    <div class="col">
                        <select2 :options="msgTypeOptions" v-model="params.msgType" :label="'Message Type'"/>
                    </div>
                    <div class="col">
                        <!--<select2 :options="languageOptions" v-model="params.lang" :label="'Language'"/>-->
                        <basic-input :label="'Recipient'" v-model="params.addr"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <select2 :options="clientCdOptions" v-model="params.clientCd" :label="'Client Code'"/>
                    </div>
                    <div class="col">
                        <select2 :options="searchTypeOptions" v-model="params.searchType" :label="'Search Type'"/>
                    </div>
                    <div class="col">
                        <input-search :label="'Search Text'" v-model="params.searchText" @search="search"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="card block-target">
            <div class="card-header header-elements-inline pt-2 pb-2">
                <h5 class="card-title"/>
                <div class="header-elements w-100">
                    <div class="list-icons">
                        <paging :page-info="pageInfo" @search="search" v-if="pageInfo.pages.length > 0"/>
                    </div>
                    <div class="list-icons ml-auto">
                        <block-target ref="blockTarget" @search="search" :class="'list-icons-item'"/>
                    </div>
                </div>
            </div>
            <modal-table class="hover-table" :fields="tableFields" name="logs" :list="logs" @rowClickEvent="onRowClick" :target-modal="`#${logDetailModal}`">
                <template v-slot:clientCd="slotData">
                    {{slotData.data.clientCd | changeOptionsValueToText(clientCdOptions)}}
                </template>
                <template v-slot:msgType="slotData">
                    {{slotData.data.msgType | changeOptionsValueToText(msgTypeOptions)}}
                </template>
                <template v-slot:time="slotData">
                    {{slotData.data.sysUpdDtm | datetimeFormat('HH:mm DD/MM/YYYY')}}
                </template>
                <template v-slot:status="slotData">
                    {{slotData.data.status | changeOptionsValueToText(logStatusTypeOptions)}}
                </template>
                <template v-slot:addr="slotData">
                    {{slotData.data.addr||'' | toBeShortString(40)}}
                </template>
            </modal-table>
        </div>
        <log-detail-modal :target="logDetailModal" :info="logInfo"/>
    </div>
</template>

<script>
    import BlockTarget from "@/components/block/BlockTarget";
    import Select2 from "@/components/form/select/Select2";
    // import DateRangePicker from "@/components/form/datepicker/DateRangePicker";
    import RelativeAbsolutDateRangePicker from "@/components/form/datepicker/RelativeAbsolutDateRangePicker";
    import InputSearch from "@/components/form/input/InputSearch";
    import BasicInput from "@/components/form/input/BasicInput";
    import Paging from "@/components/pagination/Paging";
    import api from "@/api/logs"
    import LogDetailModal from "@/components/modal/LogDetailModal";
    import ModalTable from "@/components/form/table/ModalTable";
    export default {
        name: "SendLogs",
        components:{
            ModalTable,
            LogDetailModal,
            BlockTarget,
            Select2,
            // DateRangePicker,
            RelativeAbsolutDateRangePicker,
            InputSearch,
            BasicInput,
            Paging,
        },
        data() {
            return {
                // Log Detail Modal
                logDetailModal: 'logDetailModal',
                logInfo: {},

                params:{
                    page:0,
                },
                period:null,
                message:'',
                searchType:'eventId',
                tableFields:[
                    {key:'seq',label:'Seq No',width:'10%'},
                    {key:'eventId',label:'Event Id',width:'15%'},
                    {key:'clientCd',label:'Client Code',width:'15%',slot:'clientCd'},
                    {key:'msgType',label:'message Type',width:'10%',slot:'msgType'},
                    /*{key:'lang',label:'Language',width:'5%'},*/
                    {key:'addr',label:'Recipient',width:'20%',slot:'addr'},
                    {key:'status',label:'Status',width:'15%',slot:'status'},
                    {key:'sysUpdDtm',label:'Send Date',width:'20%',slot:'time'},
                ],
                searchTypeOptions: [
                    {text:'Event Id',value:'eventId'},
                    {text:'User Id',value:'userId'},
                ],
                searchText:'',
                logs:[],
                pageInfo:{
                    pages:[1],
                    page:1,
                },
            }
        },
        computed: {
            clientCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.CLIENT_CD_OPTIONS]()
            },
            languageOptions: function() {
                return this.$store.getters[this.$const.GETTERS.LANGUAGE_OPTIONS]()
            },
            msgTypeOptions: function() {
                return this.$store.getters[this.$const.GETTERS.MSG_TYPE_OPTIONS]()
            },
            legacyParams: function() {
                return this.$store.getters[this.$const.GETTERS.GET_LEGACY_PARAMS]()[this.$route.name]
            },
            logStatusTypeOptions: function() {
                return this.$store.getters[this.$const.GETTERS.LOG_STATUS_TYPE_OPTIONS]()
            },
        },
        mounted() {
            if(this.legacyParams) this.params = this.legacyParams
            this.search()
        },
        methods: {
            search:function(page) {
                let params = $.extend(true,{},this.params)
                typeof page !== 'undefined' ? params.page = page : params.page = 0
                if(params.searchType) {
                    params[params.searchType] = this.params.searchText
                }
                if(params.period) {
                    params.startDtm = this.$moment.unix(this.params.period.start).format('YYYY-MM-DD[T]HH:mm:ss')
                    params.endDtm = this.$moment.unix(this.params.period.end).format('YYYY-MM-DD[T]HH:mm:ss')
                }
                if(params.addr) {
                    let addr = params.addr.replace(/</g,"").replace(/>/g,"").replace(/!/g,"")
                    params.addr = addr
                    this.params.addr = addr
                }
                this.$refs.blockTarget.block()
                api.getLogs(params).then((res) => {
                    let response = this.resObj(res,true)
                    this.logs = response.content
                    this.pageInfo = response.pageInfo
                }).finally(()=> {
                    this.$refs.blockTarget.unblock()
                })
            },
            onRowClick: function (item, modalCb) {
                api.getLogDetail(item.seq).then((res) => {
                    if(res && res.data && res.data.code === 1000) {
                        this.logInfo = res.data.content
                        modalCb()
                    } else {
                        throw res
                    }
                }).catch((e)=>{
                    this.$notify.error(e)
                }).finally(()=> {
                    this.$refs.blockTarget.unblock()
                })
            },
        },
        beforeRouteLeave (to, from, next) {
            this.$store.commit(this.$const.MUTATE.SET_LEGACY_PARAMS,{name:from.name,params:this.params})
            next()
        },
    }
</script>

<style scoped>

</style>
